import styled from 'styled-components';
import { TextareaAutosize, CircularProgress } from '@mui/material';
import colors from '../../../../../../../styles/colors';

const Container = styled.div`
    margin-bottom: 10px;
    width: 100%;
`;

const SuggestedResponseHeader = styled.div`
  background-color: ${colors.base.primary};
  color: ${colors.base.secondary2};
  padding: 8px 16px;
  font-weight: 600;
  font-family: Roboto;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-radius: 4px 4px 0px 0px;
`;

const SuggestedResponseContent = styled.div`
  border: 2px solid ${colors.base.primary};
  border-top: none;
  padding: 16px;
  line-height: 1.5;
  font-size: 14px;
  font-family: Roboto;
  border-radius: 0px 0px 4px 4px;
`;

const AdditionalQueryTitle = styled.div`
  margin-top: 10px;
  font-size: 12px;
  font-family: Roboto;
  font-weight: 600;
  color: ${colors.base.secondary};
`;

const AdditionalQueryContent = styled(TextareaAutosize)`
  font-size: 14px;
  font-family: Roboto;
  line-height: 1.5;
  width: 100%;
  border: 1px solid ${colors.shades.secondary7};
  border-radius: 4px;
  padding: 8px;
  margin-top: 10px;
  resize: vertical;
`;

const Button = styled.button`
  background-color: ${colors.base.secondary2};
  color: ${colors.base.alpha};
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  font-size: 15px;
  font-family: Roboto;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background-color: ${colors.shades.secondary3};
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 10px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const ButtonGroupContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
`;

const StyledCircularProgress = styled(CircularProgress)`
  margin-left: 8px;
  color: ${colors.base.primary};
`;

const GeneratedResponseContainer = styled.div`
 display: flex;
`;

export {
  Container,
  SuggestedResponseHeader,
  SuggestedResponseContent,
  AdditionalQueryTitle,
  AdditionalQueryContent,
  Button,
  ButtonContainer,
  ButtonGroupContainer,
  ToggleContainer,
  StyledCircularProgress,
  GeneratedResponseContainer,
};
